import { Image } from '@chakra-ui/react';
import React from 'react';
import zaraLogoIcon from '../../assets/images/ZaraLogo20251105.png';


const ZaraLogo = ({ ...props }) => {
    return (
        <Image
            onMouseDown={(e) => e.preventDefault()}
            alt=''
            width='188px'
            height='30px'
            {...props}
            src={zaraLogoIcon}
        />
    );
};

export default ZaraLogo;
